// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalView_modalContainer__ZalT9","modalFullscreen":"ModalView_modalFullscreen__Hkj5-"};